import { AuthUserContextProvider } from './AuthUserContext';
import { CypressUserContextProvider } from './CypressUserContextProvider';
import { TestUserContextProvider } from './TestUserContextProvider';

export const UserContextProvider =
  'Cypress' in window
    ? CypressUserContextProvider
    : process.env.NODE_ENV === 'development'
    ? TestUserContextProvider
    : AuthUserContextProvider;
